module.exports = __webpack_public_path__ + "static/media/T_Right.f3241522.svg";